import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import OSM from "ol/source/OSM";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";

export const OSMLayer = new TileLayer({
  name: "Altlık Harita (Uydu Görüntüsü)",
  desc: "katman",
  tip: "basemap",
  visible: true,
  zIndex: 1,
  source: new XYZ({
    url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
  }),
  crossOrigin: "anonymous",
});

export const OSMLayer2 = new TileLayer({
  name: "Altlık Harita (OSM)",
  desc: "katman",
  tip: "basemap",
  visible: false,
  zIndex: 0,
  source: new OSM(),
});

export const tbbIlceler = new ImageLayer({
  name: "İlçe",
  desc: "katman",
  tip: "vector",
  visible: true,
  zIndex: 2,
  source: new ImageWMS({
    url: "https://gisservices.trabzon.bel.tr/geoserver-cloud/cbs/wms",
    params: { LAYERS: "cbs:maks_ilce_public", srs: "EPSG:5257" },
    serverType: "geoserver",
  }),
});

export const tbbMahalle = new ImageLayer({
  name: "Mahalle",
  desc: "katman",
  tip: "vector",
  visible: true,
  zIndex: 3,
  source: new ImageWMS({
    url: "https://gisservices.trabzon.bel.tr/geoserver-cloud/cbs/wms",
    params: { LAYERS: "cbs:maks_mahalle_public", srs: "EPSG:5257" },
    serverType: "geoserver",
  }),
});

export const tbbYol = new ImageLayer({
  name: "Yol",
  desc: "katman",
  tip: "vector",
  visible: true,
  zIndex: 4,
  source: new ImageWMS({
    url: "https://gisservices.trabzon.bel.tr/geoserver-cloud/cbs/wms",
    params: { LAYERS: "cbs:maks_yol_katman_public", srs: "EPSG:5257" },
    serverType: "geoserver",
  }),
});

export const tbbYapi = new ImageLayer({
  name: "Yapı",
  desc: "katman",
  tip: "vector",
  visible: true,
  zIndex: 3,
  source: new ImageWMS({
    url: "https://gisservices.trabzon.bel.tr/geoserver-cloud/cbs/wms",
    params: { LAYERS: "cbs:maks_yapi_public", srs: "EPSG:5257" },
    serverType: "geoserver",
  }),
});

export const tbbDigerYapi = new ImageLayer({
  name: "Diğer Yapı",
  desc: "katman",
  tip: "vector",
  visible: true,
  zIndex: 3,
  source: new ImageWMS({
    url: "https://gisservices.trabzon.bel.tr/geoserver-cloud/cbs/wms",
    params: { LAYERS: "cbs:maks_digeryapi_public", srs: "EPSG:5257" },
    serverType: "geoserver",
  }),
});

export const tbbKapi = new ImageLayer({
  name: "Kapı",
  desc: "katman",
  tip: "vector",
  visible: true,
  zIndex: 3,
  source: new ImageWMS({
    url: "https://gisservices.trabzon.bel.tr/geoserver-cloud/cbs/wms",
    params: { LAYERS: "cbs:maks_numarataj_katman_public", srs: "EPSG:5257" },
    serverType: "geoserver",
  }),
});

export const tbbParsel = new ImageLayer({
  name: "Parseller",
  desc: "katman",
  tip: "vector",
  visible: true,
  zIndex: 3,
  source: new ImageWMS({
    url: "https://gisservices.trabzon.bel.tr/geoserver-cloud/cbs/wms",
    params: { LAYERS: "cbs:tapu_parseller_public", srs: "EPSG:4326" },
    serverType: "geoserver",
  }),
});
